import { StringHelper } from "../../../../utilities/contracts/string-helper";


export class NlpKeywordModel {
  keywordGroupType?: string;
  keywordGroupID?: number;
  keywordID?: number;
  keywordName?: string;
  keywordParsingFormula?: string;
  keywordType?: string;
  highestValue?: number;
  lowestValue?: number;

  constructor(options: {
    keywordGroupType?: string;
    keywordGroupID?: number;
    keywordID?: number;
    keywordName?: string;
    keywordParsingFormula?: string;
    keywordType?: string;
    highestValue?: number;
    lowestValue?: number;
  }) {
      this.keywordGroupType = StringHelper.clean(options.keywordGroupType);
      this.keywordGroupID = options.keywordGroupID;
      this.keywordID = options.keywordID;
      this.keywordName = StringHelper.clean(options.keywordName);
      this.keywordParsingFormula = StringHelper.clean(options.keywordParsingFormula);
      this.keywordType = StringHelper.clean(options.keywordType);
      this.highestValue = options.highestValue;
      this.lowestValue = options.lowestValue;
  }
}
